export const TRUST_COLOR = "#4361ee";
export const TRUST_BG = "#eef1fd";
export const BETRAY_COLOR = "#f08c44";
export const BETRAY_BG = "#fdf3ec";
export const MIXED_COLOR = "#9a8ec2";
export const MIXED_BG = "#f1eef9";
export const GRADIENT_BG = "linear-gradient(135deg, #dbe3fc 0%, #fbe2c9 100%)";
export const TEXT_DARK = "#1a1a2e";
export const TEXT_MUTED = "#6b7280";
export const BORDER = "#e3e3ec";
